import { FC } from "react";

import { AddYoutubeVideoModal, AddImageModal, TitledChild, SquareTabContainer } from "Components";
import { TTechnologyImageDTO, TTechnologyYoutubeVideoDTO } from "Types";
// styles
import styles from "./addMediaModal.module.scss";

type TAddMediaModal = {
    technologyId?: number,
    addImage?: (image: TTechnologyImageDTO) => void,
    addYoutubeVideo?: (video: TTechnologyYoutubeVideoDTO) => void
}

export const AddMediaModal: FC<TAddMediaModal> = ({ technologyId, addImage, addYoutubeVideo }: TAddMediaModal) => {

    return (
        <>
            <SquareTabContainer extraClassNameTabContainer={styles.modalTabContainer}>
                <TitledChild title="ADD IMAGE">
                    <AddImageModal technologyId={technologyId} addImage={addImage} />
                </TitledChild>
                <TitledChild title="ADD VIDEO">
                    <AddYoutubeVideoModal technologyId={technologyId} addYoutubeVideo={addYoutubeVideo} />
                </TitledChild>
            </SquareTabContainer>
        </>
    );
}